<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="representativeReplacements.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="180"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="representativeReplacement"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :representative-replacement="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="representativeReplacements.per_page"
        layout="total, prev, pager, next"
        :total="representativeReplacements.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'ascending',
        },
      };
    },
    computed: {
      representativeReplacements() {
        return this.$store.getters['representativeReplacement/representativeReplacements'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['representativeReplacement/tableConfig']));
      },
      loading() {
        return this.$store.getters['representativeReplacement/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('representativeReplacement/setFilterString', '');
      this.$store.commit('representativeReplacement/setCurrentPage', this.currentPage);
      this.$store.commit('representativeReplacement/setSorting', this.currentSort);
      await this.$store.dispatch('representativeReplacement/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('representativeReplacement/setCurrentPage', val);
        this.$store.dispatch('representativeReplacement/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('representativeReplacement/setSorting', { prop, order });
          this.$store.dispatch('representativeReplacement/fetchAll');
        }
      },
    },
  };
</script>

